( function () {
	const paginationContainer = document.querySelector(
		'body[class*="tax-tickers"] .posts-pagination'
	);

	if ( ! paginationContainer ) {
		return;
	}

	const scrollArticleListing = ( container ) => {
		if ( container ) {
			const articleListing =
				document.querySelector( '.articles-listing' );
			const hasAjaxPagination =
				articleListing.dataset.hasPagination ?? 'false';
			if (
				hasAjaxPagination === 'false' &&
				window.location.href.indexOf( '/page/' ) !== -1
			) {
				setTimeout( function () {
					articleListing.scrollIntoView();
				}, 1000 );
			}
		}
	};

	const initPagination = ( container ) => {
		setTimeout( () => container.classList.add( 'fouc-ready' ), 64 );
	};

	scrollArticleListing( paginationContainer );
	initPagination( paginationContainer );
} )();
